import React, { Component } from 'react'

import { connect } from 'react-redux'

import * as firebase from 'firebase'

import ContentAdd from 'material-ui/svg-icons/content/add'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import TeamViewHeader, { TeamViewMode } from './TeamHeader'
import TeamListView from './TeamListView'
import TeamTilesView from './TeamTilesView'
import MemberCard from './MemberCard'
import InMemoryMemberEditor from '../infra/InMemoryMemberEditor'
import FirebaseMemberEditor from '../infra/FirebaseMemberEditor'

class Team extends Component {

  constructor(props) {
    super(props)
    this.state = {
      searchFilter: '',
      users: [],
      viewMode: TeamViewMode.Tiles,
      editor: null
    }
  }

  componentDidMount() {
    firebase.database()
      .ref(this.props.viewModeDbPath)
      .on('value', this.onViewModeChanged)
  }

  componentWillUnmount() {
    firebase.database()
      .ref(this.props.viewModeDbPath)
      .off('value', this.onViewModeChanged)
  }

  onUsersChanged = (snapshot) => {
    this.setState({ users: snapshot.val() })
  }

  onViewModeChanged = (snapshot) => {
    const value = snapshot.val()
    // default to tiles view if not set.
    if (!value || value === TeamViewMode.Tiles) {
      this.setState({ viewMode: TeamViewMode.Tiles })
    }
    else {
      this.setState({ viewMode: value })
    }
  }

  handleViewModeUpdated = (viewMode) => {
    // update view mode value in DB with the user seletion.
    firebase.database().ref(this.props.viewModeDbPath).set(viewMode)
  }

  handleSearchFilterUpdated = (searchFilter) => {
    this.setState({ searchFilter })
  }

  handleNewMemberTapped = () => {
    this.setState({
      editor: new InMemoryMemberEditor(this.props.teamInfo, this.props.teamMembers, this.props.currentUser, {countryCode: this.props.userCountryCode})
    })
  }

  handleMemberSelected = (memberId) => {
    const teamMember = this.props.teamMembers.find(m => m.userId === memberId);
    const numberParsed = teamMember.dbKey.split(' ');
    const countryCode = numberParsed[0] || '';
    const number = numberParsed[1] || '';

    this.setState({
      editor: new FirebaseMemberEditor(
        firebase,
        Object.assign({}, teamMember, {countryCode, number}),
        this.props.currentUser,
        this.props.teamInfo.id)
    })
  }

  handleActionCanceled = () => {
    this.setState({ editor: null })
  }

  handleActionCompleted = () => {
    this.setState({ editor: null })
  }

  render() {
    const visibleMembers = this.props.teamMembers
      .filter(member => this.state.searchFilter === ''
        || member.displayName.toLowerCase().indexOf(this.state.searchFilter.toLowerCase()) !== -1)
    return (
      <div style={styles.teamViewStyles}>
        <FloatingActionButton
          style={styles.newMemberButtonStyles}
          onTouchTap={this.handleNewMemberTapped}>
          <ContentAdd />
        </FloatingActionButton>
        <TeamViewHeader searchFilter={this.state.searchFilter}
          viewMode={this.state.viewMode}
          onSearchFilterUpdated={this.handleSearchFilterUpdated}
          onViewModeUpdated={this.handleViewModeUpdated}/>
        {
          this.state.viewMode === TeamViewMode.List
            ? <TeamListView list={visibleMembers} onMemberSelected={this.handleMemberSelected} />
            : <TeamTilesView list={visibleMembers} onMemberSelected={this.handleMemberSelected} />
        }
        <MemberCard
          editor={this.state.editor}
          onActionCanceled={this.handleActionCanceled}
          onActionCompleted={this.handleActionCompleted} />
      </div>
    )
  }

}

const styles = {
  teamViewStyles: {
    flexDirection: 'column',
    display: 'flex',
    overflow: 'auto',
    backgroundColor: 'white',
    width: '100%'
  },
  newMemberButtonStyles: {
    margin: 10,
    position: 'fixed',
    bottom: 85,
    right: 13
  }
}

const getUserCountryCode = (state) => {
  const userMetadata = state.firebase.user.metadata
  if (userMetadata
    && userMetadata.value
    && userMetadata.value.areaCode) {
    return userMetadata.value.areaCode
  }
  return null
}

const mapStateToProps = (state) => {
  const teamMembers = state.firebase.team.members.value
  const teamId = state.firebase.team.metadata.value.id
  const currentUserId = state.firebase.userAuth.id
  const userCountryCode = getUserCountryCode(state) || ''

  return {
    teamMembers,
    teamInfo: state.firebase.team.metadata.value,
    currentUser: teamMembers.find(m => m.userId === currentUserId),
    userCountryCode: userCountryCode,
    viewModeDbPath: `users/${state.firebase.userAuth.id}/settings/viewMode/${teamId}/teamViewMode/`
  }
}

export default connect(mapStateToProps)(Team)



// WEBPACK FOOTER //
// ./src/team/Team.js